import { fromJS } from 'immutable'
import config from '../config'

import {
  startAuthCheck, finishAuthCheck, setUserLogin, setAuthCheckError, setADandJiraUser, getExtraUserInfo
} from '../auth/actions.js'

let defaultState = fromJS({
  hasAuthCheckStarted: false,
  hasAuthCheckFinished: false,
  loginError: null,
  userToken: null,
  adUserInfo: null,  
  oktaToken: null,
  jiraUser: null
})

export default function auth (state = defaultState, action) {
  state = fromJS(state) // Force immutable in case of rehydration
  switch (action.type) {
    case startAuthCheck.type:
      return state.set('hasAuthCheckStarted', true)
        .set('hasAuthCheckFinished', false)
    case setAuthCheckError.type:
      return state.set('hasAuthCheckFinished', true)
        .set('loginError', action.payload)
    case finishAuthCheck.type:
      return state.set('hasAuthCheckFinished', true)
    case setUserLogin.type:
      return state.set('userToken', action.payload ? fromJS(action.payload) : null)
    case setADandJiraUser.type:        
    case getExtraUserInfo.event.success:
      let userInfo = {}
      userInfo.username = action.payload.sAMAccountName      
      userInfo.firstName = action.payload.givenName
      userInfo.lastName = action.payload.sn
      userInfo.displayName = action.payload.givenName + ' ' + action.payload.sn
      userInfo.email = action.payload.mail
      userInfo.groups = action.payload.groups
      state = state.set('adUserInfo', userInfo)
      state = state.set('jiraUser', action.payload.jiraUser)      
      state = state.set('isAdmin', action.payload && action.payload.groups && action.payload.groups.includes(config.adminGroup))
      return state
    default:
      return state
  }
}

export const isLoggedIn = state => state.auth.get('userToken') !== null
export const selectUsername = state => state.auth.getIn(['userToken', 'username'])
export const selectEmail = state => state.auth.getIn(['userToken', 'email'])
export const hasAuthCheckStarted = state => state.auth.get('hasAuthCheckStarted')
export const hasAuthCheckFinished = state => state.auth.get('hasAuthCheckFinished')
export const selectUserAccessToken = state => state.auth.getIn(['userToken', 'accessToken'])
export const selectLoginError = state => state.auth.get('loginError')
export const selectADUserInfo = state => state.auth.get('adUserInfo')
export const selectJiraUser = state => state.auth.get('jiraUser')
export const isAdmin = state => state.auth.get('isAdmin')



// WEBPACK FOOTER //
// ./client/src/auth/reducer.js